import { ValidateSignature } from './getters/ValidateSignature';
var getters = {
    ValidateSignature: ValidateSignature,
};
var SingersValidator = {
    getters: getters,
};
export { SingersValidator };
